var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.grade === 2 ? 'title2nd' : ''},[(_vm.icon)?_c('svg-icon',{attrs:{"icon":_vm.icon,"class-name":'icon'}}):_vm._e(),_c('span',{staticClass:"title",attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }